module.exports = __webpack_public_path__ + "img/DD_Site_Header.c14f3bbe.jpg";